import RegVehicle from "./RegVehicle"

export default  RegVehicle;
